import React from 'react';

import { useApp } from '../../store/AppContext';
import { frenchDate } from '../../utils/format';

export default function PhaseOverrunDialog() {
  const { phaseExtendConfirm, setPhaseExtendConfirm } = useApp();
  const { clientName, phaseName, phaseEnd, newEnd, onExtend, onKeep } = phaseExtendConfirm;
  return (
    <div className="modal w-[480px] max-w-[92vw]" onClick={(e) => e.stopPropagation()}>
      <div className="text-[15px] font-bold text-navy mb-[10px]">Dépassement de phase</div>
      <div className="text-[13px] text-[#444] leading-[1.6] mb-[18px]">
        La fin de la phase{' '}
        <strong>
          {clientName} · {phaseName}
        </strong>{' '}
        est prévue pour le <strong>{frenchDate(phaseEnd)}</strong>, mais cette affectation se
        termine le <strong>{frenchDate(newEnd)}</strong>.
      </div>
      <div className="flex justify-end flex-wrap gap-[8px]">
        <button className="btn" onClick={() => setPhaseExtendConfirm(null)}>
          Annuler l'affectation
        </button>
        <button className="btn" onClick={onKeep}>
          Garder sans prolonger
        </button>
        <button className="btn btn-primary" onClick={onExtend}>
          Allonger la phase jusqu'au {frenchDate(newEnd)}
        </button>
      </div>
    </div>
  );
}
